import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { acceptItemPriceChangeApi } from './acceptItemPriceChange.api'
import acceptItemPriceChangeInitialState from './acceptItemPriceChange.initialState'
import { AcceptItemPriceChangeErrorResponse, AcceptItemPriceChangeRequestPayload } from './acceptItemPriceChange.types'

export const acceptItemPriceChange = createAsyncThunk(
  urls.items.acceptItemPriceChange,
  async (payload: AcceptItemPriceChangeRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await acceptItemPriceChangeApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const acceptItemPriceChangeSlice = createSlice({
  name: urls.items.acceptItemPriceChange,
  initialState: acceptItemPriceChangeInitialState,
  reducers: {
    // Add any additional reducers here
  },
  extraReducers: (builder) => {
    builder
      .addCase(acceptItemPriceChange.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(acceptItemPriceChange.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(acceptItemPriceChange.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as AcceptItemPriceChangeErrorResponse
        state.success = null
      })
  }
})

export const { actions: acceptItemPriceChangeActions, reducer: acceptItemPriceChangeReducer } =
  acceptItemPriceChangeSlice
export default acceptItemPriceChangeSlice.reducer
